import React, { Fragment } from "react";
import { Tag, Intent } from "@blueprintjs/core";

class ParticipantsList extends React.Component {
  render() {
    const { sessionInstance, sequenceDisplayed, feedBacks, session, removeParticipants} =
      this.props;
    const { participants = [], results = [], currentStep } = sessionInstance;
    let feedBackQuestions = session.data.feedbacks;
    let feeds = false;
    if (feedBacks) {
      feeds = Object.keys(feedBacks);
    }
    let i = 0;

    let participantsList = participants.filter(p => !p.isParticipantFromPreviousSession);

    if (currentStep === "HOME") {
      return (
        <Fragment>
          <button
            onClick={() => removeParticipants()
            }
            className="d-none-comp monitor-participants"
          >
            Remove participants from previous session
          </button>
          <div className="col-xs-12 participants">
            <div className="title">
              Participants list - {participantsList.length} participants <br />
            </div>
            {participantsList.map((p, index) => {
              // eslint-disable-next-line
              return (
                <Tag
                  key={index}
                  intent={Intent.SUCCESS}
                  large={true}
                  minimal={true}
                  className="participant-status animated zoomIn">
                  {p.infos.name}
                </Tag>
              );
            })}
          </div>
        </Fragment>
      );
    } else if (currentStep === "SEQUENCES") {
      return (
        <div className="col-xs-12 participants">
          <div className="title">
            List of participants who did not respond (last 10)
          </div>
          {participantsList?.map((p, index) => {
            // eslint-disable-next-line
            if (results[sequenceDisplayed.id][p.id] || i >= 10) return;
            i++;
            return (
              <Tag
                key={index}
                intent={
                  currentStep !== "SEQUENCES"
                    ? Intent.NONE
                    : results[sequenceDisplayed.id][p.id]
                    ? Intent.SUCCESS
                    : Intent.WARNING
                }
                large={true}
                minimal={true}
                className="participant-status animated zoomIn">
                {p.infos.name}
              </Tag>
            );
          })}
        </div>
      );
    } else if (currentStep === "FEEDBACKS") {
      return (
        <div className="col-xs-12 participants">
          <div className="title">
            List of participants who did not respond to feedback (last 10)
          </div>
          {!feeds
            ? participantsList.map((participant, i) => (
                <Tag
                  key={i}
                  intent={Intent.WARNING}
                  large={true}
                  minimal={true}
                  className="participant-status animated zoomIn">
                  {participant.infos.name}
                </Tag>
              ))
            : // eslint-disable-next-line
              participantsList.map((participant, i) => {
                // eslint-disable-next-line
                let participantFound = feeds.find(
                  (feed) => feed === participant.id
                );
                let answers = false;
                if (participantFound) {
                  answers = Object.keys(feedBacks[participantFound]);
                }
                if (
                  !participantFound ||
                  (answers &&
                    Object.keys(feedBacks[participantFound]).length <
                      feedBackQuestions.length)
                ) {
                  return (
                    <Tag
                      key={i}
                      intent={Intent.WARNING}
                      large={true}
                      minimal={true}
                      className="participant-status animated zoomIn">
                      {participant.infos.name}
                    </Tag>
                  );
                } else {
                  console.log("");
                }
              })}
        </div>
      );
    } else {
      return null;
    }
  }
}
export default ParticipantsList;
